export default __webpack_public_path__ + "static/media/WebMoney_logo_blue.072683f5.svg";